import { Container } from 'react-bootstrap'
import { addDaysToDateInString } from '../../../helpers'
import { ImageBase64 } from '../../image/image'
import CarDescriptionBlock from './carDescriptionBlock'
import { IProposalVehicleProps } from './proposalTypes'
import * as S from './proposalElements'

interface IInputProps {
  proposalUpdatedDate?: string | null
  pdf?: boolean
  vehicle: IProposalVehicleProps
}

const CarImageSection = (props: IInputProps) => {
  return (
    <div className="card-section">
      <Container className="section mt-4">
        {!props.pdf && (
          <>
            {props.proposalUpdatedDate && (
              <div className="mb-2 text-center">
                Proposal valid until{' '}
                {addDaysToDateInString(props.proposalUpdatedDate, 90)}
              </div>
            )}
            <CarDescriptionBlock
              vehicle={props.vehicle}
              vehicleType={props.vehicle.vehicleType}
            />
            {props.vehicle && props.vehicle.id && (
              <div className="text-center">
                {props.vehicle && props.vehicle.vehicleDescription}
              </div>
            )}
            {props.vehicle && !props.vehicle.id && (
              <div className="text-dark-black mb-4 text-center">
                {props.vehicle && props.vehicle.vehicleDescription}
              </div>
            )}
          </>
        )}
        <S.CentredImageDiv>
          <div
            className={
              'car-image car-image-large mb-3 pb-0' + (props.pdf
                ? 'pdf-image-border'
                : '')
            }
          >
            {props.vehicle &&
              props.vehicle.id &&
              props.vehicle.vehicleImage && (
                <ImageBase64
                  ImageBase64Encoded={props.vehicle.vehicleImage.base64Image}
                  style={{ maxWidth: '100%', maxHeight: '100%' }}
                />
              )}
            {(!props.vehicle ||
              !props.vehicle.id ||
              !props.vehicle.vehicleImage) && (
              <img
                src="/images/car-image-default.svg"
                alt=""
                style={{ maxWidth: '100%', maxHeight: '100%' }}
              />
            )}
          </div>
        </S.CentredImageDiv>
        <p className="text-smaller text-center">Image is indicative only</p>
      </Container>
    </div>
  )
}

export default CarImageSection
